// Implementations: LocalPredictionCache, future RemotePredictionCache.

export class PredictionCache {
  /* eslint-disable no-unused-vars */
  async getMany(keys) { throw new Error('not implemented'); }
  async putMany(entries) { throw new Error('not implemented'); }
  async removeMany(keys) { throw new Error('not implemented'); }
  /* eslint-enable no-unused-vars */
}
